import type { ColumnDef } from '../projects/projectsColumns';

export const samplesColumns: ColumnDef[] = [
  { field: 'SampleReference', headerName: 'Sample Reference', sortable: true, flex: 1 },
  { field: 'SampleId', headerName: 'Sample ID', sortable: true, width: 110 },
  { field: 'ProjectName', headerName: 'Project', sortable: true, flex: 1 },
  { field: 'LocationName', headerName: 'Location', sortable: true, flex: 0.8 },
  { field: 'DepthTop', headerName: 'Depth Top (m)', sortable: true, width: 115 },
  { field: 'DepthBase', headerName: 'Depth Base (m)', sortable: true, width: 115 },
  { field: 'SampleType', headerName: 'Type', sortable: true, width: 100 },
  { field: 'Status', headerName: 'Status', sortable: true, width: 110, type: 'status' },
  { field: 'Priority', headerName: 'Priority', sortable: true, width: 100 },
  { field: 'Condition', headerName: 'Condition', sortable: true, width: 100 },
];
